import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSwitch,
        popUpMessageChange, 
        standByCardsGroupsChange,
        editCards,
        editFeaturesGroup, 
        editFigures,
        responseDataChange } from '../../actions';

import { _ } from '../../functions/translator.js';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { addDaysToDate, getDaysDiffBetweenDates } from '../../functions/utils';
import { showMessage } from '../../functions/popUpMessage.js';
import { findCardsGroupsRelatedTeams } from '../../functions/finder.js';
import { Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { ToggleActions } from '../../constants/constants.js';

class ReleaseDate extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            minDate: new Date().toISOString().slice(0, 10),
            maxDate: addDaysToDate(new Date(), 30).toISOString().slice(0, 10),
            selectedDate: new Date().toISOString().slice(0, 10),
        }
    }

    handleClose = () => {
        if (this.props.releaseDateSwitch) {
            this.props.toggleSwitch(ToggleActions.RELEASE_DATE)
        }
    }

    handleDateChange = (event) => {
        this.setState({ 
            selectedDate: event.target.value
        })
    }

    releaseCardsGroups = async () => {
        this.handleClose();
        const message = _("Liberando") + ' ' + (this.props.standByCardsGroups.length === 1 ? ' ' + _("protocolo") : ' ' + _("protocolos")) + '...';
        showMessage(this.props, message, { loading: true });
        const teamIds = findCardsGroupsRelatedTeams(
            this.props.standByCardsGroups,
            this.props.projectData.cards_groups,
            this.props.projectData.teams
        )
        const teamShiftDict = {};
        for (const teamId of teamIds) {
            const teamShiftKey = `${teamId}_shift_id`;
            teamShiftDict[teamId] = this.state[teamShiftKey];
        }
        const urlPost = {
            project_id: this.props.projectData.id,
            cards_group_ids: this.props.standByCardsGroups,
            finish_date: this.state.selectedDate,
            team_shift_dict: teamShiftDict
        };
        const response = await postData('/web-api/release', urlPost);
        this.props.responseDataChange(response);
        this.handleResponse(response);
    }

    handleResponse = (response) => {
        if(response.status === 'success') {
            showMessage(this.props, '¡' + _('Se han liberado los protocolos correctamente') + '!');
        } else {
            const message = _('Los siguientes protocolos no se pudieron liberar') + ': ';
            const messageConfig = {
                closeButton: true,
                releaseFail: true,
            }
            showMessage(this.props, message, messageConfig);
        }
        let cardsGroupIdsToReload = this.getCardsGroupIdsToReload(response);
        reloadCardsGroupsFeatures(this.props, cardsGroupIdsToReload);
        this.props.standByCardsGroupsChange([]);
    }

    getCardsGroupIdsToReload(response) {
        let cardsGroupIdsToReload = [...this.props.standByCardsGroups];
        if (response.not_team) {
            cardsGroupIdsToReload = cardsGroupIdsToReload.filter((cardsGroupId) => {
                return !response.not_team.includes(cardsGroupId);
            });
        }
        if (response.not_protocol) {
            cardsGroupIdsToReload = cardsGroupIdsToReload.filter((cardsGroupId) => {
                return !response.not_protocol.includes(cardsGroupId);
            });
        }
        if (response.not_releasable) {
            cardsGroupIdsToReload = cardsGroupIdsToReload.filter((cardsGroupId) => {
                return !response.not_releasable.includes(cardsGroupId);
            });
        }
        return cardsGroupIdsToReload
    }

    getShiftSelectors = () => {
        const shiftsDataArray = Object.values(this.props.projectData.shifts);
        const shiftSelectors = [];
        if (!shiftsDataArray.length) {
            return shiftSelectors;
        }
        const shiftsList = [
            <MenuItem value={0} key={0}>
                {_('Ninguno')}
            </MenuItem>
        ];
        for (const shiftData of shiftsDataArray) {
            shiftsList.push(
                <MenuItem value={shiftData.id} key={shiftData.id}>
                    {shiftData.attributes.name}
                </MenuItem>
            );
        }
        const teamIds = findCardsGroupsRelatedTeams(
            this.props.standByCardsGroups,
            this.props.projectData.cards_groups,
            this.props.projectData.teams
        )
        for (const teamId of teamIds) {
            const teamData = this.props.projectData.teams[teamId];
            const teamShiftKey = `${teamId}_shift_id`;
            const teamInfo = this.getTeamInfo(teamData);
            shiftSelectors.push(
                <div>
                    <p className='text'>
                        { teamData.attributes.name }
                        <Tooltip arrow 
                            title={ teamInfo } placement="right">
                            <InfoOutlinedIcon color='primary' style={{ fontSize: 20 }} className='float-right'/>
                        </Tooltip>
                    </p>
                    <Select
                        name={teamShiftKey}
                        value={this.state[teamShiftKey]}
                        displayEmpty={true}
                        renderValue={this.getShiftRenderValue}
                        onChange={this.handleShiftChange}>
                        {shiftsList}
                    </Select>
                </div>
            );
        }
        return shiftSelectors;
    }

    getTeamInfo = (teamData) => {
        const usersInfo = [];
        for (const userId of Object.keys(teamData.users)) {
            const userData = this.props.projectUsers[userId];
            if (!userData) continue;
            const userWorkshiftData = Object.values(userData.workshifts).filter(workshiftData => workshiftData.attributes.team_id === teamData.id)[0];
            const shiftId = userWorkshiftData ? userWorkshiftData.attributes.shift_id : 0;
            const shiftData = this.props.projectData.shifts[shiftId];
            const shiftName = shiftData ? shiftData.attributes.name : _('Sin Turno');
            const userName = `${userData.attributes.first_name} ${userData.attributes.last_name}`;
            usersInfo.push(
                <tr>
                    <td>{userName}</td>
                    <td>{shiftName}</td>
                </tr>
            );
        }
        const usersInfoTable = <table className='item-info-table'>{usersInfo}</table>;
        return usersInfoTable;
    }

    handleShiftChange = (event) => {
        const teamShiftKey = event.target.name;
        const shiftIdSelected = event.target.value;
        this.setState({ [teamShiftKey]: shiftIdSelected });
    }
    
    getShiftRenderValue = (shiftIdSelected) => {
        if (shiftIdSelected) {
            return this.props.projectData.shifts[shiftIdSelected].attributes.name;
        }
        return _('Ninguno');
    }

    render(){   
        let render = this.props.releaseDateSwitch && this.props.standByCardsGroups.length > 0;
        const daysDiff = getDaysDiffBetweenDates(this.state.minDate, this.state.selectedDate);
        const shiftSelectors = this.getShiftSelectors();
        return (
            <div>
                { render ? (
                    <div>
                        <div className='sensitive-background' onClick={ this.handleClose }></div>
                        <div className="signature-card-layout card-color">
                            <h3 className='text-center mt-2 mb-4'>{_("Ingresar Fecha de Término")}</h3>
                            <TextField
                                label={_("Fecha")}
                                type="date"
                                value={this.state.selectedDate}
                                onChange={this.handleDateChange}
                                className='date-component'
                                variant='outlined'
                                inputProps={{
                                    min: this.state.minDate,
                                    max: this.state.maxDate
                                }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                            <p className='release-date-text'>
                                {_('En')} 
                                <span className='release-date-days'>{ daysDiff }</span> 
                                {_('días el registro se considerará atrasado, si aún no ha sido cerrado') + '.'}
                            </p>

                            { shiftSelectors.length ?
                                <div className='release-date-text'>
                                    <p className='text'>{ _('Elegir Turno Encargado') }</p>
                                    <div className='shift-selectors-container px-4 pb-4'>
                                        { shiftSelectors }
                                    </div>
                                </div>
                                : null
                            }

                            <div className='d-flex justify-content-center mt-1 mb-2'>
                                <Button 
                                    variant="contained" 
                                    className='confirm-success-button' 
                                    onClick={ this.releaseCardsGroups }
                                    disabled={false}>
                                    <SendIcon/>
                                    { _('Liberar') }
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        )
    }
}

function mapStateToProps( state ){
    return {
        projectData        : state.projectData,
        projectUsers       : state.projectUsers,
        releaseDateSwitch  : state.switches.releaseDate,
        standByCardsGroups : state.standByCardsGroups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        popUpMessageChange : popUpMessageChange,
        standByCardsGroupsChange : standByCardsGroupsChange,
        responseDataChange : responseDataChange,
        editCards : editCards,
        editFeaturesGroup : editFeaturesGroup,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ReleaseDate)